module.exports = __webpack_public_path__ + "static/img/K-360-1.c47dd184.png";